module.exports = __webpack_public_path__ + "img/945-934d97.png";